import { FormControl, FormGroup, FormRecord } from '@angular/forms';
import { FormEntity } from '@blockframes/utils/form/forms/entity.form';
import { ExpenseType } from '@blockframes/model';
import { Expense } from '@blockframes/model';
import { ExpenseForm } from './statement.form';
import { atLeastOneLetter } from '@blockframes/utils/form';

function createExpenseTypeControl(config?: Partial<ExpenseType>, versionIds: string[] = []) {

  const defaultValue = config?.cap?.default ?? 0;
  const version = {};
  for (const id of versionIds) {
    version[id] = new FormControl<number>(config.cap.version[id] ?? defaultValue);
  }
  return {
    id: new FormControl<string>(config?.id ?? ''),
    name: new FormControl<string>(config?.name ?? '', [atLeastOneLetter]),
    cap: new FormGroup({
      default: new FormControl<number>(defaultValue),
      version: new FormRecord(version)
    }),
    contractId: new FormControl<string>(config?.contractId ?? ''),
  };
}

type ExpenseTypeControl = ReturnType<typeof createExpenseTypeControl>;

export class ExpenseTypeForm extends FormEntity<ExpenseTypeControl> {
  constructor(config?: Partial<ExpenseType>, versionIds: string[] = []) {
    super(createExpenseTypeControl(config, versionIds));
  }
}

interface ExpenseChange {
  override: Expense,
  confirm: string,
}

function createExpenseEditFormControl(changes?: Partial<ExpenseChange>) {
  const controls = {
    override: new ExpenseForm(changes?.override ?? {}),
    confirm: new FormControl<string>(changes?.confirm ?? '')
  };
  return controls;
}

type ExpenseEditFormControl = ReturnType<typeof createExpenseEditFormControl>;

export class ExpenseEditForm extends FormEntity<ExpenseEditFormControl> {
  constructor(changes?: Partial<ExpenseChange>) {
    super(createExpenseEditFormControl(changes));
  }
}
